/**
 * Validates a single field in an address form.
 * @param {string} name - Field name
 * @param {string} value - Field value
 * @returns {string|null} - Error message or null if valid
 */
export const validateAddressField = (name, value) => {
  if (["street", "city", "state", "zip"].includes(name)) {
    if (!value?.toString().trim() || value === "-") {
      return `${name.charAt(0).toUpperCase() + name.slice(1)} is required`;
    }
  }

  if (name === "zip") {
    const zipStr = value.toString().trim();

    if (!/^\d{5,10}$/.test(zipStr)) {
      return "Zip code must be between 5 and 10 digits";
    }
  }

  return null;
};

/**
 * Validates the entire address form data.
 * @param {object} address - Address data object
 * @returns {object} - Object containing errors for each field
 */
export const validateAddressForm = (address) => {
  const errors = {};
  const fields = ["street", "city", "state", "zip"];

  fields.forEach((field) => {
    const error = validateAddressField(field, address[field] || "");
    if (error) errors[field] = error;
  });

  return errors;
};
